"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = require("@osmosys/utils");
const constants_1 = require("../constants");
const findBlockWithEl_1 = require("../utils/dom/findBlockWithEl");
const isDirectOsysChild_1 = require("../utils/dom/isDirectOsysChild");
const findEls_1 = require("../utils/dom/findEls");
const hasAttr_1 = require("../utils/dom/hasAttr");
const getAttr_1 = require("../utils/dom/getAttr");
const elToHtmlString_1 = require("../utils/dom/elToHtmlString");
const mergeTags_1 = require("../mergeTags");
const stringToDocument_1 = require("../utils/dom/stringToDocument");
const getElLogName_1 = require("../utils/general/getElLogName");
const getAncestorBlockArray_1 = require("../utils/general/getAncestorBlockArray");
const getBlockDisplayName_1 = require("../utils/general/getBlockDisplayName");
const social_1 = require("../social");
const utils_2 = require("../utils");
class BlueprintTemplateRenderer {
    // Log the initialize event
    constructor(options) {
        this.defaultOptions = {
            respectDefaults: false,
        };
        this.options = Object.assign(Object.assign({}, this.defaultOptions), options);
        utils_1.logger.debug(`BlueprintTemplateRenderer.constructor | respectDefaults: ${options.respectDefaults}`);
    }
    // Allow options to be updated
    setOptions(options) {
        this.options = Object.assign(Object.assign({}, this.defaultOptions), options);
    }
    // public writeIdsIntoHtmlDocumentString(
    //   html: string,
    //   blocks: EmailTemplateBlock[]
    // ): string {
    //   const el = this.writeIdsIntoEl(stringToDocument(html), blocks);
    //   return el instanceof Document ? el.documentElement.outerHTML : el.outerHTML;
    // }
    // public writeIdsIntoEl(
    //   parentEl: Document | HTMLElement,
    //   blocks: EmailTemplateBlock[]
    // ): Document | HTMLElement {
    //   blocks.map(block => {
    //     if (!block.id) {
    //       logger.warn(
    //         'BlueprintTemplateRenderer.writeIdsIntoEl | Block has no ID. Exiting with a no-op'
    //       );
    //       return;
    //     }
    //     const selector = `[_osys:cid="${block.clientId}"]`;
    //     const el = parentEl.querySelector(`[_osys:cid="${block.clientId}"]`);
    //     if (!el) {
    //       logger.warn(`No el found for Block #${block.id} using ${selector}`);
    //     }
    //     if (block.childBlocks) {
    //       this.writeIdsIntoEl(el as HTMLElement, block.childBlocks);
    //     }
    //   });
    //   return parentEl;
    // }
    renderRepeaterEl(repeaterEl, repeaterBlock
    // parent?: IBlockElementMetaObj
    ) {
        utils_1.logger.debug('BlueprintTemplateRenderer.renderRepeaterEl | RENDERING...');
        repeaterEl.innerHTML = '';
        if (repeaterBlock.childBlocks) {
            repeaterBlock.childBlocks.map(childBlock => {
                utils_1.logger.debug("BlueprintTemplateRenderer.renderRepeaterEl | LOOKING FOR CHILD BLOCK'S MATCHING REPEATING BLOCK...");
                repeaterEl.insertAdjacentHTML('beforeend', childBlock.parsedHtml || '');
            });
        }
        return repeaterEl;
    }
    // Take an HTML string and modify it with data from blocks
    renderHtmlDocumentString(html, blocks) {
        utils_1.logger.debug('BlueprintTemplateRenderer.renderHtmlDocumentString');
        const el = this.renderEl(stringToDocument_1.stringToDocument(html), blocks);
        if (!el || el === null) {
            return '';
        }
        return mergeTags_1.mergeTags(elToHtmlString_1.elToHtmlString(el));
    }
    // Take a DOM element and transform it with data from blocks
    renderEl(containingEl, blocks, parent) {
        utils_1.logger.debug({ blocks }, 'BlueprintTemplateRenderer.renderEl | RENDERING...');
        const ancestors = parent && parent.block ? getAncestorBlockArray_1.getAncestorBlockArray(parent.block) : [];
        const logPrefix = 'BlueprintTemplateRenderer.renderEl ' +
            (`[${!parent ? '' : getBlockDisplayName_1.getBlockDisplayName(parent.block)}${getElLogName_1.getElLogName(containingEl)}]` +
                ancestors.reduce((a, b) => `${a}--->[${getBlockDisplayName_1.getBlockDisplayName(b)}]`, '') +
                '---> |').toUpperCase();
        const elements = findEls_1.findEls(containingEl, 'osys');
        utils_1.logger.debug(`${logPrefix} LOOKING FOR ${parent ? `${ancestors.length + 1}x NESTED` : 'TOP-LEVEL'} BLOCKS`);
        // Only look for direct children
        const directChildEls = elements.filter(childEl => {
            return isDirectOsysChild_1.isDirectOsysChild(childEl, containingEl);
        });
        // Exclude Elements with no _osys:id or _osys:cid
        let idCount = 0;
        let cidCount = 0;
        const elsWithIds = directChildEls.filter(el => {
            const hasId = hasAttr_1.hasAttr(el, 'id');
            const hasCid = hasAttr_1.hasAttr(el, 'cid');
            if (hasId) {
                idCount = idCount + 1;
            }
            if (hasCid) {
                cidCount = cidCount + 1;
            }
            return hasId || hasCid;
        });
        const elsWithBlocks = elsWithIds.reduce((arr, el) => {
            const block = findBlockWithEl_1.findBlockWithEl(el, blocks);
            const id = getAttr_1.getAttr(el, 'id');
            const cid = getAttr_1.getAttr(el, 'cid');
            if (block) {
                arr.push({
                    block,
                    cid: cid || undefined,
                    el,
                    id: id || undefined,
                });
            }
            else {
                const idSelector = `${id ? `[${constants_1.OSYS_ATTRS.id}="${id}"]` : ''}${cid ? `[${constants_1.OSYS_ATTRS.cid}="${cid}"]` : ''}`;
                utils_1.logger.error(`${logPrefix} No matching Blocks found for ${idSelector} | This is a no-op`);
            }
            return arr;
        }, []);
        utils_1.logger.debug(`${logPrefix} FOUND ${elsWithBlocks.length} ELEMENT(S) THAT MATCH BLOCKS IN PEDIGREE. | [[FILTER TREE]] --> [[FOUND ${elements.length} [osys] TAG(S)]] --> [[FOUND ${directChildEls.length} DIRECT CHILD(REN)]] --> [[FOUND ${elsWithIds.length} WITH [_osys:id|_osys:cid] ATTRIBUTES (${idCount} have [_osys:id]) (${cidCount} have [_osys:cid])]]`);
        elsWithBlocks.map(({ block, cid, id, el }) => {
            // Repeaters are special, because we need to place new [osys] tags into the DOM...
            // So the idea with running this before 'field' or 'group' is that, this will write the
            // HTML and then they will proceed normally, without needing to contain any repeater-specific
            // logic.
            if (block.type === 'repeater') {
                el = this.renderRepeaterEl(el, block);
            }
            utils_1.logger.debug(`${logPrefix} DECIDING WHAT TO DO WITH BLOCK OF TYPE '${block.type}' WITH CID OF '${cid}' AND ID OF ${id}`);
            // Hide block
            if (block.hideable) {
                el.setAttribute('_osys:hideable:user:hidden', block.hidden ? 'true' : 'false');
                if (block.hidden) {
                    utils_1.logger.debug(`${logPrefix} HIDING HIDEABLE BLOCK...`);
                    // TODO: UNCOMMENT THESE LINES TO REMOVE ELEMENTS. BE WARNED, IF WE REMOVE ELEMENTS RIGHT NOW, THERE WILL BE NO WAY FOR THOSE ELEMENTS TO COME BACK AFTER THE EMAIL'S HTML HAS BEEN SAVED TO THE DATABASE, BCEAUSE THE ELEMENT WON'T BE ON THE DOM. IT'S A CATCH 22
                    if (el && el.style) {
                        const originalDisplayStyle = el.getAttribute('_osys:hideable:original:display:style');
                        if (el.style.display && !originalDisplayStyle) {
                            el.setAttribute('_osys:hideable:original:display:style', el.style.display);
                        }
                        el.style.display = 'none';
                    }
                    // if (el.parentNode) {
                    //   el.parentNode.removeChild(el);
                    //   return el;
                    // } else {
                    //   logger.warn(
                    //     `${logPrefix} Hidden Block has no parentNode for Block ${id} { $ }{cid} | Attempting to set outerHTML to ''...`
                    //   );
                    //   try {
                    //     el.outerHTML = '';
                    //     return el;
                    //   } catch (e) {
                    //     logger.error(
                    //       `${logPrefix} Setting outerHTML to '' failed (see https:// developer.mozilla.org/en-US/docs/Web/API/Element/outerHTML): ${e}`
                    //     );
                    //     return el;
                    //   }
                    // }
                }
                else {
                    utils_1.logger.debug(`${logPrefix} SHOWING HIDEABLE BLOCK...`);
                    if (el && el.style && el.style.display === 'none') {
                        const originalDisplayStyle = el.getAttribute('_osys:hideable:original:display:style');
                        if (originalDisplayStyle && originalDisplayStyle !== 'none') {
                            el.style.display = originalDisplayStyle;
                        }
                        else {
                            el.style.removeProperty('display');
                        }
                        el.removeAttribute('_osys:hideable:original:display:style');
                    }
                }
            }
            // Populate field values
            if (block.type === 'social') {
                const url = utils_2.getEmailTemplateBlockDataForKey(block, 'link', true, true) ||
                    utils_2.getEmailTemplateBlockDataForKey(block, 'url', true, true);
                const title = utils_2.getEmailTemplateBlockDataForKey(block, 'title', true, true);
                const image = utils_2.getEmailTemplateBlockDataForKey(block, 'image', true, true) ||
                    utils_2.getEmailTemplateBlockDataForKey(block, 'photo', true, true);
                if (!url || !block.contentItem) {
                    el.style.display = 'none';
                }
                else {
                    el.style.removeProperty('display');
                }
                // TODO: validate for 'a' tags
                if (block.socialProvider) {
                    const shareLinks = social_1.getShareLinks({
                        image,
                        title,
                        url,
                    });
                    el.setAttribute('href', shareLinks[block.socialProvider]);
                }
                else {
                    el.setAttribute('href', url);
                }
                el.setAttribute('target', el.getAttribute('target') || '_blank');
            }
            else if (block.type === 'field') {
                utils_1.logger.debug(`${logPrefix} POPULATING FIELD VALUE(S)...`);
                if (block.fieldType === 'ad') {
                    let adCodeHtml = '';
                    adCodeHtml = block.ad
                        ? block.ad.html
                        : this.options.respectDefaults
                            ? el.innerHTML
                            : '';
                    // Populate context variables
                    if (block.adContexts) {
                        adCodeHtml = block.adContexts.reduce((html1, ctx) => {
                            return Object.entries(ctx.contextVariables || {}).reduce((html2, [k, v]) => {
                                return html2.replace(new RegExp(k, 'g'), v);
                            }, html1);
                        }, adCodeHtml);
                    }
                    el.innerHTML = mergeTags_1.mergeTags(adCodeHtml);
                }
                else {
                    const data = typeof block.contentStr === 'string'
                        ? block.contentStr
                        : block.contentItem &&
                            block.contentFieldKey &&
                            block.contentItem[block.contentFieldKey] &&
                            block.contentItem[block.contentFieldKey].data
                            ? block.contentItem[block.contentFieldKey].data
                            : '';
                    // Use the hardcoded defaults if respectDefaults and there isn't any content overriding the defaults
                    const useDefaults = this.options.respectDefaults === true &&
                        (!data || `${data.trim()}` === '');
                    if (!useDefaults) {
                        if (!block.selectedTargets || block.selectedTargets.length === 0) {
                            utils_1.logger.warn(`${logPrefix} Field has no selectedTargets`);
                        }
                        else {
                            // Loop through all of the field targets, populating the needed attributes or inner contents
                            block.selectedTargets.map(target => {
                                if (constants_1.OSYS_CHILD_TARGETS.includes(target)) {
                                    if (block.fieldType === 'html' ||
                                        block.usingRichContentEditor) {
                                        el.innerHTML = data || '';
                                    }
                                    else {
                                        el.innerText = data || '';
                                    }
                                }
                                else {
                                    utils_1.logger.debug(`${logPrefix} Setting attribute ${target} to ${data}`);
                                    el.setAttribute(target, data || '');
                                }
                            });
                        }
                    }
                }
            }
            // Recurse through child blocks for 'field' and 'group' { block } types
            // if (block.type === 'field' || block.type === 'group') {
            if (block.childBlocks) {
                el = this.renderEl(el, block.childBlocks, {
                    block,
                    cid,
                    el,
                    id,
                });
            }
            // }
            // logger.debug(
            //   `${logPrefix} EMPTYING REPEATER HTML AND POPULATING ${
            //     block.childBlocks ? block.childBlocks.length : 0
            //   } REPEATED CHILD BLOCK(S)...`
            // );
            // el.innerHTML = '';
            // if (block.childBlocks) {
            //   block.childBlocks.map(b => {
            //     logger.debug(`${logPrefix} ${b.parsedHtml}`);
            //     el.append('row');
            //     // el.innerHTML += this.renderHtmlDocumentString(
            //     //   b.parsedHtml || '',
            //     //   b.childBlocks || []
            //     // );
            //     // el.innerHTML += b.parsedHtml;
            //     // el.append( || '');
            //   });
            // }
            // Return element
            return el;
        });
        // Look inside of osys:fields for inline ads, and take
        // their html from the attribute and put it on the DOM
        containingEl
            .querySelectorAll('[osys\\:field] [osys\\:ad\\:html][osys\\:ad\\:id]')
            .forEach(a => {
            a.innerHTML = a.getAttribute('osys:ad:html') || '';
        });
        return containingEl;
    }
}
exports.BlueprintTemplateRenderer = BlueprintTemplateRenderer;
//# sourceMappingURL=BlueprintTemplateRenderer.js.map